var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160 0H32C14.3269 0 0 14.3269 0 32V160C0 177.673 14.3269 192 32 192H160C177.673 192 192 177.673 192 160V32C192 14.3269 177.673 0 160 0Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 168C135.765 168 168 135.765 168 96C168 56.2355 135.765 24 96 24C56.2355 24 24 56.2355 24 96C24 135.765 56.2355 168 96 168Z",
    fill: "#342F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 152C126.928 152 152 126.928 152 96C152 65.0721 126.928 40 96 40C65.0721 40 40 65.0721 40 96C40 126.928 65.0721 152 96 152Z",
    fill: "#171616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 96C144 69.4903 122.51 48 96 48C69.4903 48 48 69.4903 48 96C48 122.51 69.4903 144 96 144C122.51 144 144 122.51 144 96Z",
    fill: "#F26D6B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M126 84C135.941 84 144 75.9411 144 66C144 56.0589 135.941 48 126 48C116.059 48 108 56.0589 108 66C108 75.9411 116.059 84 126 84Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.521bc9e82cb849fb6687522ee6f374be.svg";
export { ForwardRef as ReactComponent };